const IST_TZ = 'Asia/Kolkata';

// Parse date strings that may come from mysql2 with dateStrings:true
// Format: "YYYY-MM-DD HH:MM:SS" — already in IST since backend pool uses timezone:'+05:30'
function parseDate(dateStr) {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;
  if (typeof dateStr === 'string') {
    // MySQL DATETIME: "2025-04-09 15:30:00" — append IST offset so JS parses correctly
    const m = dateStr.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})/);
    if (m) {
      const d = new Date(`${m[1]}T${m[2]}+05:30`);
      if (!isNaN(d.getTime())) return d;
    }
    // MySQL DATE only: "2025-04-09"
    const md = dateStr.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (md) {
      const d = new Date(`${md[1]}T00:00:00+05:30`);
      if (!isNaN(d.getTime())) return d;
    }
  }
  const fallback = new Date(dateStr);
  return isNaN(fallback.getTime()) ? null : fallback;
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = parseDate(dateStr);
  if (!d) return String(dateStr);
  return d.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
    timeZone: IST_TZ,
  }) + ' IST';
}

export function formatShortDate(dateStr) {
  if (!dateStr) return '—';
  const d = parseDate(dateStr);
  if (!d) return String(dateStr);
  return d.toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    timeZone: IST_TZ,
  });
}
